// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3s2Yq","list":"BalanceDue_list__Wn5EY","listRow":"BalanceDue_listRow__1QcM0","total":"BalanceDue_total__8N5dX"};